import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { JwtHelperService, JWT_OPTIONS } from '@auth0/angular-jwt';
import { AuthGuardService } from './_services/auth/auth-guard.service';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LocationStrategy, Location, PathLocationStrategy, CommonModule } from '@angular/common';
import { SocialLoginModule,FacebookLoginProvider } from 'angularx-social-login';
import { AppRoutingModule } from './app.routing';
import { ComponentsModule } from './components/components.module';
import { DemoMaterialModule } from './layouts/admin-layout/Materialmodule';
import { UserActionComponent } from './pages/user-action/user-action.component';
import { SponsorComponent } from './pages/sponsor/sponsor.component';
import { HomeComponent } from './pages/home/home.component';
import { FileUploadModule } from 'ng2-file-upload';
import { SnotifyModule, SnotifyService, ToastDefaults } from 'ng-snotify';
import { NgxPaginationModule } from 'ngx-pagination';
import { WeatherComponent } from './pages/weather/weather/weather.component';
import { AddStageComponent } from './pages/stage/add-stage/add-stage.component';
import {  ReactiveFormsModule } from '@angular/forms';
import { BrowserModule , Meta } from '@angular/platform-browser';
import { NavBarComponent } from './pages/layout/nav-bar/nav-bar.component';
import { FootersComponent } from './pages/layout/footers/footers.component';
import { AcceuilComponent } from './pages/acceuil/acceuil.component';
import { ContactComponent } from './pages/contact/contact.component';
import { MusicComponent } from './pages/music/music.component';
import { NgxAudioPlayerModule } from 'ngx-audio-player';
import { EventsFrontComponent } from './pages/events-front/events-front.component';
import { NewsLatersComponent } from './pages/news-laters/news-laters.component';
import { ProjetsComponent } from './pages/projets/projets.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { DocumentsComponent } from './pages/documents/documents.component';
import { ComplexeComponent } from './pages/complexe/complexe.component';
import { SponsorsComponent } from './pages/sponsors/sponsors.component';
import { BureauComponent } from './pages/bureau/bureau.component';
import { HistoriqueComponent } from './pages/historique/historique.component';
import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { PostsComponent } from './pages/posts/posts.component';
import { NextEventComponent } from './pages/next-event/next-event.component';
import { GetPostIdComponent } from './pages/get-post-id/get-post-id.component';
import { GetEventIdComponent } from './pages/get-event-id/get-event-id.component';
import {  NgbdModalContent } from './pages/posts/modal.component';
import {NgbdModalContentt} from './pages/acceuil/modal.component';
import { CarouselFontComponent } from './pages/carousel-font/carousel-font.component';
import { CarouselMobileComponent } from './pages/carousel-mobile/carousel-mobile.component';
import { CarouselOffiMobileComponent } from './pages/carousel-offi-mobile/carousel-offi-mobile.component';
import { CarouselOffiWebComponent } from './pages/carousel-offi-web/carousel-offi-web.component';
import { GetPostByIdComponent } from './pages/get-post-by-id/get-post-by-id.component';
import { LoadingComponent } from './pages/loading/loading.component';
import { RapportFrontComponent } from './pages/rapport-front/rapport-front.component';
import { NgxSpinnerModule } from "ngx-spinner";

import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';

registerLocaleData(localeFr, 'fr');
//import { AgmCoreModule } from '@agm/core';
//import {} from 'googlemaps';
@NgModule({
  imports: [
    NgxAudioPlayerModule,
    PdfViewerModule,
    BrowserModule,
    CommonModule ,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    ComponentsModule,
    DemoMaterialModule,
    SnotifyModule,
    NgxPaginationModule,
    FileUploadModule ,
    NgxSpinnerModule,
    NgbModule,
    RouterModule,
    AppRoutingModule,
    SocialLoginModule,
    MDBBootstrapModule.forRoot()

  ], schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
  declarations: [
    AppComponent,
    AdminLayoutComponent,
    AuthLayoutComponent,
    UserActionComponent,
    SponsorComponent,
    HomeComponent,
    WeatherComponent,
    AddStageComponent,
    NavBarComponent,
    FootersComponent,
    AcceuilComponent,
    ContactComponent,
    MusicComponent,
    EventsFrontComponent,
    NewsLatersComponent,
    ProjetsComponent,
    DocumentsComponent,
    ComplexeComponent,
    SponsorsComponent,
    BureauComponent,
    HistoriqueComponent,
    PostsComponent,
    NextEventComponent,
    GetPostIdComponent,
    GetEventIdComponent,
    NgbdModalContent,
    NgbdModalContentt,
    CarouselFontComponent,
    CarouselMobileComponent,
    CarouselOffiMobileComponent,
    CarouselOffiWebComponent,
    GetPostByIdComponent,
    LoadingComponent,
    RapportFrontComponent
  ],
  providers: [
    {provide: LOCALE_ID, useValue: 'fr' },
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
    JwtHelperService,
    AuthGuardService,
    { provide: 'SnotifyToastConfig', useValue: ToastDefaults},
    SnotifyService , Meta
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
